var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24.125,
    width: 24,
    height: 24,
    rx: 8,
    transform: "rotate(-180 24 24.125)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.472 17.6577C13.7662 17.9493 14.2411 17.9472 14.5327 17.653C14.8243 17.3588 14.8222 16.8839 14.528 16.5923L12.765 14.845C12.0495 14.1359 11.5587 13.6478 11.2266 13.2343C10.904 12.8326 10.7933 12.5746 10.7639 12.3435C10.7454 12.1984 10.7454 12.0516 10.7639 11.9065C10.7933 11.6754 10.904 11.4174 11.2266 11.0157C11.5587 10.6022 12.0495 10.1141 12.765 9.405L14.528 7.65769C14.8222 7.36611 14.8243 6.89124 14.5327 6.59704C14.2411 6.30284 13.7662 6.30073 13.472 6.59231L11.6773 8.3711C11.0013 9.04104 10.4489 9.58859 10.0571 10.0765C9.64963 10.5838 9.3547 11.0987 9.27591 11.7168C9.24136 11.9879 9.24136 12.2621 9.27591 12.5332C9.3547 13.1513 9.64963 13.6662 10.0571 14.1735C10.4489 14.6614 11.0013 15.209 11.6773 15.8789L13.472 17.6577Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeft);
export default __webpack_public_path__ + "static/media/carousel_left.2b323c55b2c279104abdedf71e98e078.svg";
export { ForwardRef as ReactComponent };